import { inject, injectable } from "inversify";
import { JSONFElogging, RvkAdminServiceInterface } from "@apphq/rvk-client";
import { LoggingService } from "@apphq/logging";

export abstract class TokenProvider {
  abstract getToken(): string | null;
}

export abstract class RoleChecker {
  abstract $watch<T>(
    watching: (store: RoleChecker) => T,
    cb: (value: T) => any
  ): void;

  abstract isLoggedIn: boolean;
  abstract hasRole(role: string): boolean;
}

@injectable()
export class LoggingServiceAdapter implements LoggingService {
  constructor(
    @inject(RvkAdminServiceInterface)
    private rvkadminClient: RvkAdminServiceInterface
  ) {}

  webLogging(logEntry: JSONFElogging) {
    return this.rvkadminClient.felogging(logEntry);
  }
}
